"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const Modal_1 = __importDefault(require("react-bootstrap/Modal"));
const JkcTime = (props) => {
    const { name, settings, onChangeEvent } = props;
    const timeRef = (0, react_1.useRef)();
    const [timePickerModalIsOpen, setTimePickerIsOpen] = react_1.default.useState(false);
    const timeJson = [
        { value: "12:15 PM" },
        { value: "12:30 PM" },
        { value: "12:45 PM" },
        { value: "1:00 PM" },
        { value: "1:15 PM" },
        { value: "1:30 PM" },
        { value: "1:45 PM" },
        { value: "2:00 PM" },
        { value: "2:15 PM" },
        { value: "2:30 PM" },
        { value: "2:45 PM" },
        { value: "3:00 PM" },
        { value: "3:15 PM" },
        { value: "3:30 PM" },
        { value: "3:45 PM" },
        { value: "4:00 PM" },
        { value: "4:15 PM" },
        { value: "4:30 PM" },
        { value: "4:45 PM" },
        { value: "5:00 PM" },
        { value: "5:15 PM" },
        { value: "5:30 PM" },
        { value: "5:45 PM" },
        { value: "6:00 PM" },
        { value: "6:15 PM" },
        { value: "6:30 PM" },
        { value: "6:45 PM" },
        { value: "7:00 PM" },
        { value: "7:15 PM" },
        { value: "7:30 PM" },
        { value: "7:45 PM" },
        { value: "8:00 PM" },
        { value: "8:15 PM" },
        { value: "8:30 PM" },
        { value: "8:45 PM" },
        { value: "9:00 PM" },
        { value: "9:15 PM" },
        { value: "9:30 PM" },
        { value: "9:45 PM" },
        { value: "10:00 PM" },
        { value: "10:15 PM" },
        { value: "10:30 PM" },
        { value: "10:45 PM" },
        { value: "11:00 PM" },
        { value: "11:15 PM" },
        { value: "11:30 PM" },
        { value: "11:45 PM" },
        { value: "12:00 AM" },
        { value: "12:15 AM" },
        { value: "12:30 AM" },
        { value: "12:45 AM" },
        { value: "1:00 AM" },
        { value: "1:15 AM" },
        { value: "1:30 AM" },
        { value: "1:45 AM" },
        { value: "2:00 AM" },
        { value: "2:15 AM" },
        { value: "2:30 AM" },
        { value: "2:45 AM" },
        { value: "3:00 AM" },
        { value: "3:15 AM" },
        { value: "3:30 AM" },
        { value: "3:45 AM" },
        { value: "4:00 AM" },
        { value: "4:15 AM" },
        { value: "4:30 AM" },
        { value: "4:45 AM" },
        { value: "5:00 AM" },
        { value: "5:15 AM" },
        { value: "5:30 AM" },
        { value: "5:45 AM" },
        { value: "6:00 AM" },
        { value: "6:15 AM" },
        { value: "6:30 AM" },
        { value: "6:45 AM" },
        { value: "7:00 AM" },
        { value: "7:15 AM" },
        { value: "7:30 AM" },
        { value: "7:45 AM" },
        { value: "8:00 AM" },
        { value: "8:15 AM" },
        { value: "8:30 AM" },
        { value: "8:45 AM" },
        { value: "9:00 AM" },
        { value: "9:15 AM" },
        { value: "9:30 AM" },
        { value: "9:45 AM" },
        { value: "10:00 AM" },
        { value: "10:15 AM" },
        { value: "10:30 AM" },
        { value: "10:45 AM" },
        { value: "11:00 AM" },
        { value: "11:15 AM" },
        { value: "11:30 AM" },
        { value: "11:45 AM" },
        { value: "12:00 PM" },
    ];
    let labelStyle = {
        marginBottom: "0px",
        position: settings.isNormalLabel ? "relative" : "absolute",
        paddingLeft: settings.isNormalLabel ? "0px" : "7px",
        zIndex: 999,
        fontSize: "16px",
        fontWeight: "bold",
    };
    let inputStyle = {
        width: "100%",
        padding: settings.isNormalLabel ? "0px 5px 0px 5px" : "10px 0px 0px 5px",
        fontSize: "15px",
        border: "1px solid #D3D3D3",
        outline: "none",
    };
    let iconStyle = {
        position: "absolute",
        right: "14px",
        lineHeight: settings.inputStyle.height,
    };
    const handleTimeSelect = (value) => {
        onChangeEvent(value);
        setTimePickerIsOpen(false);
    };
    let fieldStyle = {
        position: "relative",
        width: "100%",
        display: settings.fieldTypes == "Grid" ? "flex" : "block",
        borderTop: settings.fieldTypes == "Grid" ? "1px solid #dddddd" : "none",
        borderBottom: settings.fieldTypes == "Grid" ? "1px solid #dddddd" : "none",
        marginTop: "-1px",
    };
    if (settings.fieldTypes == "Grid") {
        fieldStyle.alignItems = "center";
    }
    let fieldLablStyle = {
        width: settings.fieldTypes == "Grid" ? "30%" : "100%",
        padding: settings.fieldTypes == "Grid" ? "10px 10px" : "0px",
    };
    let fieldInputStyle = {
        width: settings.fieldTypes == "Grid" ? "70%" : "100%",
        padding: settings.fieldTypes == "Grid" ? "10px 10px" : "0px",
        borderLeft: settings.fieldTypes == "Grid" ? "1px solid #dddddd" : "none",
        position: "relative",
    };
    if (settings.fieldTypes == "Grid") {
        fieldLablStyle.textAlign = "right";
    }
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: fieldStyle, ref: timeRef, className: "component-area-cn" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ style: fieldLablStyle }, { children: !settings.hideLabel ? ((0, jsx_runtime_1.jsx)("label", Object.assign({ style: Object.assign(Object.assign({}, labelStyle), settings.labelStyle), htmlFor: name }, { children: settings.label ? settings.label : "Label" }))) : null })), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: fieldInputStyle }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ style: Object.assign(Object.assign({}, settings.inputStyle), { padding: 0 }) }, { children: [(0, jsx_runtime_1.jsx)("input", { id: settings.id ? settings.id : name, name: name, tabIndex: settings.tabIndex ? settings.tabIndex : undefined, disabled: false, readOnly: settings.readOnly ? settings.readOnly : false, placeholder: settings.placeholder ? settings.placeholder : "", type: "text", className: settings === null || settings === void 0 ? void 0 : settings.className, style: Object.assign(Object.assign({}, inputStyle), settings.inputStyle), value: settings.value, onChange: onChangeEvent, onClick: () => setTimePickerIsOpen(true) }), (0, jsx_runtime_1.jsx)("i", { className: "fa-solid fa-alarm-clock", style: Object.assign(Object.assign(Object.assign({}, iconStyle), { bottom: settings.fieldTypes == "Grid" ? "10px" : "0px" }), settings.iconStyle), onClick: () => setTimePickerIsOpen(true) }), (0, jsx_runtime_1.jsxs)(Modal_1.default, Object.assign({ show: timePickerModalIsOpen, onHide: () => setTimePickerIsOpen(false), size: "xl", centered: true }, { children: [(0, jsx_runtime_1.jsx)(Modal_1.default.Header, Object.assign({ closeButton: true }, { children: "Select Time" })), (0, jsx_runtime_1.jsx)(Modal_1.default.Body, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ style: { display: "flex", flexWrap: "wrap" } }, { children: timeJson.map(function (params) {
                                            return ((0, jsx_runtime_1.jsx)("div", Object.assign({ onClick: () => handleTimeSelect(params.value), style: {
                                                    display: "inline-block",
                                                    border: "1px solid #ccc",
                                                    padding: "3px 5px",
                                                    margin: "3px",
                                                    minWidth: "100px",
                                                    textAlign: "center",
                                                    cursor: "pointer",
                                                } }, { children: (0, jsx_runtime_1.jsx)("p", Object.assign({ style: { margin: 0 } }, { children: params.value })) }), params.value));
                                        }) })) })] }))] })) }))] })));
};
exports.default = JkcTime;
